module.exports = __webpack_public_path__ + "img/logo.b7398e6a.png";